import { render, staticRenderFns } from "./ScoringMapSelector.vue?vue&type=template&id=c7cb8938&scoped=true&"
import script from "./ScoringMapSelector.vue?vue&type=script&lang=ts&"
export * from "./ScoringMapSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ScoringMapSelector.vue?vue&type=style&index=0&id=c7cb8938&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7cb8938",
  null
  
)

export default component.exports